<!-- Register form -->
@if (submitted) {
  <div class="rc-loader__full-page">
    <app-loader></app-loader>
  </div>
}

<app-auth-login></app-auth-login>

@if (registerForm) {
  <form
    id="register-form"
    [formGroup]="registerForm"
    (submit)="onSubmit()"
    class="rc-content-v-middle form-container"
    autocomplete="off"
  >
    <div class="form-container__grid">
      <!-- First Name -->
      <div class="register-form__input">
        <rc-field
          id="registerFieldFirstName"
          [autocomplete]="'off'"
          [error]="firstNameControlError()"
          [maxlength]="50"
          [placeholder]="'registerApp_fieldFirstName' | translate"
          data-cs-mask
          formControlName="firstName"
        ></rc-field>
      </div>

      <div class="register-form__input">
        <!-- Last Name  -->
        <rc-field
          id="registerFieldLastName"
          [autocomplete]="'disable'"
          [error]="lastNameControlError()"
          [maxlength]="50"
          [placeholder]="'registerApp_fieldLastName' | translate"
          data-cs-mask
          formControlName="lastName"
        ></rc-field>
      </div>

      <!-- Email -->
      @if (loginType === loginTypeEnum.email) {
        <div #registerLoginField class="register-form__input">
          <rc-field
            id="registerFieldEmail"
            [autocomplete]="'off'"
            [error]="emailControlError()"
            [placeholder]="'registerApp_fieldEmailAddress' | translate"
            data-cs-mask
            formControlName="email"
          >
          </rc-field>
        </div>
      }

      <!-- Country -->
      <div class="register-form__input">
        <rc-autocomplete
          id="registerFieldCountry"
          [error]="countryLabelControlError()"
          [items]="countryLabels"
          [placeholder]="'registerApp_fieldCountry' | translate"
          formControlName="countryLabel"
        >
        </rc-autocomplete>
      </div>
      @if (loginType === loginTypeEnum.primaryPhone) {
        <div #registerLoginField class="register-form__input">
          <rc-phone-field
            id="registerFieldPhone"
            [error]="
              (getFirstErrorControl(registerForm.controls.primaryPhone)
                | translate) || null
            "
            [label]="'registerApp_fieldPrimaryPhone' | translate"
            formControlName="primaryPhone"
          ></rc-phone-field>
        </div>
      }
      <!-- Password -->
      <div
        [class.mobile-auto-height]="showPopover"
        class="register-form__input register-form__input--passoword"
      >
        <rc-field
          id="registerFieldPassword"
          [autocomplete]="'off'"
          [error]="
            registerForm.controls.password.touched &&
            registerForm.controls.password.invalid &&
            !showPopover &&
            ('SetPassword_rules6' | translate)
          "
          [placeholder]="'registerApp_fieldEnterPassword' | translate"
          [type]="showPassword ? 'text' : 'password'"
          (blur)="popoverClose()"
          (focus)="popoverOpen()"
          formControlName="password"
        >
          <div
            (click)="showPassword = !showPassword"
            class="password-eye"
            role="button"
            suffix
          >
            @if (!showPassword) {
              <img alt="eye stroke" src="/assets/icons/eye-stroke.svg" />
            }

            @if (showPassword) {
              <img alt="eye open" src="/assets/icons/eye-open.svg" />
            }
          </div>
        </rc-field>

        @if (showPopover) {
          <div
            class="rc-input--error-message form-container__password-errors popover"
          >
            <p class="form-container__password-rule">
              {{ 'SetPassword_rules0' | translate }}
            </p>
            <ul>
              @for (
                validationMessage of validationMessages.password.slice(1);
                track validationMessage.type
              ) {
                <li
                  [class.success__color]="
                    !(
                      registerForm.controls.password.hasError(
                        validationMessage.type
                      ) ||
                      registerForm.controls.password.hasError(
                        validationMessages.password[0].type
                      )
                    )
                  "
                  class="form-container__password-rule"
                >
                  {{ validationMessage.message }}
                </li>
              }
            </ul>

            <div class="popover__arrow--scale">
              <div class="popover__arrow"></div>
            </div>
          </div>
        }
      </div>

      <!-- Password Confirm -->
      <div class="register-form__input register-form__input--password-confirm">
        <rc-field
          id="registerFieldConfPassword"
          [autocomplete]="'off'"
          [error]="passwordConfirmControlError()"
          [placeholder]="'registerApp_fieldConfirmPassword' | translate"
          [type]="showPasswordConfirm ? 'text' : 'password'"
          formControlName="passwordConfirm"
        >
          <div
            (click)="showPasswordConfirm = !showPasswordConfirm"
            class="password-eye"
            suffix
          >
            @if (!showPasswordConfirm) {
              <img alt="eye stroke" src="/assets/icons/eye-stroke.svg" />
            }

            @if (showPasswordConfirm) {
              <img alt="eye open" src="/assets/icons/eye-open.svg" />
            }
          </div>
        </rc-field>
      </div>
    </div>

    <div class="info-container">
      <div>
        {{
          environmentService.getTranslationPrefix() +
            'registerApp_registerInfo1' | translate
        }}
      </div>
      <div>
        {{
          environmentService.getTranslationPrefix() +
            'registerApp_registerInfo2' | translate
        }}
        {{ 'registerApp_registerInfo3' | translate }}
      </div>
    </div>
    <!-- Consents checkboxs -->
    <app-consents-form
      [countryCodeFormControl]="registerForm.controls.countryLabel"
      [form]="registerForm.controls.consents"
    ></app-consents-form>

    <div class="form-container__button">
      <a (click)="goBack()" class="rc-link form-container__button__back">{{
        'registerApp_cancel' | translate
      }}</a>
      <p class="form-container__button__or">
        {{ 'registerApp_or' | translate }}
      </p>

      <rc-button
        id="registerButton"
        [disabled]="registerForm.invalid"
        [name]="'registerApp_continue' | translate"
        type="submit"
      >
      </rc-button>
    </div>
  </form>
}
